import { AxiosError } from 'axios';

import { USERS_API_URL } from '@/constants/apis';
import { apiManager } from '@/helpers/api.manager';
import { ApiResponse } from '@/types/response.type';

const deleteUser = async (userId: string): Promise<ApiResponse<boolean>> => {
  try {
    const response = await apiManager.delete(`${USERS_API_URL}/${userId}`, {
      headers: { 'Content-Type': 'application/json' },
    });

    if (response.status !== 200) {
      const error = response as unknown as AxiosError;
      return Promise.reject(error.response?.data);
    }

    return Promise.resolve(response.data);
  } catch (e) {
    return Promise.reject(e);
  }
};

export default deleteUser;
